<template>
  <div class="notfound">
    <img src="@/assets/img/image-notfound.png" alt="" />
    <button @click="goToHome" class="btn">Got to Home Page</button>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goToHome() {
      this.$emit("showContent");
      this.$router.push("/");
    },
  },
};
</script>

<style>
.notfound {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  z-index: 999;
}
.notfound img {
  width: 50% !important;
  height: 500px;
  object-fit: cover;
}

.notfound .btn {
  background-color: var(--color-blue);
  color: var(--color-white);
}
</style>
